import React from 'react';

const Call = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none" {...props}>
      <path
        d="M24.9135 19.551C21.2772 16.6371 20.2202 18.094 18.6329 19.6831C17.4432 20.8746 14.5342 18.425 12.0875 15.9086C9.57537 13.3928 7.12991 10.4128 8.31961 9.35344C9.97234 7.69889 11.3608 6.70495 8.45173 3.06313C5.54264 -0.578078 3.55901 2.20253 1.97294 3.79162C0.12143 5.64616 1.84022 12.5316 8.64991 19.3516C15.4596 26.1056 22.3354 27.8934 24.1869 26.0395C25.7735 24.4504 28.6166 22.4637 24.9142 19.5504L24.9135 19.551Z"
        fill="currentColor"
      />
      <path
        d="M14.7422 6.96322C17.3348 6.2223 21.7052 8.14841 21.4089 12.8891"
        stroke="currentColor"
        stroke-width="1.48148"
        stroke-linecap="round"
      />
      <path
        d="M14.7422 2.14855C19.557 1.03748 26.3235 4.07447 25.8307 11.7782"
        stroke="currentColor"
        stroke-width="1.48148"
        stroke-linecap="round"
      />
    </svg>
  );
};

export default Call;
